var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91863 2.25002C8.73325 2.24142 9.49363 2.61767 9.99238 3.25642L10.7624 4.28017C11.0074 4.58642 11.3749 4.77017 11.7686 4.77017H14.4549C17.6836 4.77017 19.2586 6.49392 19.2499 10.0289V14.2902C19.2499 17.6677 17.1674 19.7502 13.7811 19.7502H7.20988C3.84113 19.7502 1.74988 17.6677 1.74988 14.2814V7.71017C1.74988 4.08767 3.35988 2.25002 6.53613 2.25002H7.91863ZM14.5511 12.5664H6.44863C6.08113 12.5664 5.79238 12.8552 5.79238 13.2227C5.79238 13.5814 6.08113 13.8789 6.44863 13.8789H14.5511C14.9099 13.8789 15.1986 13.5814 15.1986 13.2227C15.1986 12.8552 14.9099 12.5664 14.5511 12.5664Z",
    fill: "#008F8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGreen);
export default __webpack_public_path__ + "static/media/FolderGreen.045d87b9.svg";
export { ForwardRef as ReactComponent };